import ClickAwayListener from '@mui/material/ClickAwayListener';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popover from '@mui/material/Popover';
import {
  cloneElement,
  type MouseEvent,
  type ReactElement,
  useState,
} from 'react';
import { Icon } from '../display';
import type { ItemWithLabel } from '../utils';

export default function DropDownWrap({
  children,
  options,
  selected,
  onSelect,
}: {
  children: ReactElement;
  onSelect: (value: string) => void;
  options: ItemWithLabel[];
  selected?: string;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>();

  const wrapped = cloneElement(children, {
    onClick(e: MouseEvent<HTMLButtonElement>) {
      setAnchorEl(anchorEl ? undefined : e.currentTarget);
    },
  });

  function close() {
    setAnchorEl(undefined);
  }

  function onMenuClick(value: string) {
    onSelect(value);
    close();
  }

  return (
    <>
      {wrapped}
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        disableScrollLock
        open={Boolean(anchorEl)}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Paper>
          <ClickAwayListener onClickAway={close}>
            <MenuList>
              {options.map((option) => (
                <MenuItem
                  disabled={option.disabled}
                  key={option.value}
                  onClick={() => onMenuClick(option.value)}
                  selected={selected === option.value}
                >
                  {option.icon && <Icon icon={option.icon} />}
                  {option.label}
                </MenuItem>
              ))}
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Popover>
    </>
  );
}
